module.exports = function() {
  return new Worker(__webpack_public_path__ + "0f502df09f3d7eb6b799.worker.js");
};